export const FOLDER_NAME = "sister-session-helper";

export const INSTALL_COPY = {
  windowsExtract:
    "Windows: nella cartella Download fai clic destro sullo ZIP, scegli «Estrai tutto…» e premi «Estrai». Il doppio click apre solo l'anteprima dello ZIP.",
  macExtract: "Mac: nella cartella Download fai doppio click sullo ZIP.",
  doNotMoveFolder:
    `Sposta la cartella ${FOLDER_NAME} in Documenti. Dopo averla caricata in Chrome, non spostarla, non rinominarla e non cancellarla: Chrome usa i file da quella posizione.`,
  chromeExtensions: "In Chrome apri una nuova scheda, scrivi chrome://extensions nella barra degli indirizzi e premi Invio.",
  edgeExtensions: "Se usi Edge, apri edge://extensions.",
  developerMode: "Attiva «Modalità sviluppatore» in alto a destra.",
  loadUnpacked:
    `Premi «Carica estensione non pacchettizzata» (Load unpacked). Seleziona la cartella ${FOLDER_NAME} che contiene manifest.json, non lo ZIP e non la cartella padre.`,
} as const;

export const UPDATE_COPY = {
  alreadyInstalled:
    `Se l'hai già installata, non caricarne una seconda. Scarica lo ZIP nuovo ed estrailo. Copia i file della nuova cartella ${FOLDER_NAME} dentro la stessa cartella ${FOLDER_NAME} già caricata in Chrome e sostituisci i vecchi file. Non creare una cartella annidata.`,
  reload:
    "Poi su chrome://extensions, nella scheda Legacy, premi Ricarica (freccia circolare). Su Edge apri edge://extensions. Non serve Rimuovi.",
  noAutoUpdate:
    "Chrome non aggiorna da solo le estensioni caricate come cartella. Il popup avvisa con il badge ↑ e un banner quando c'è una versione nuova.",
} as const;
